import { memo, useCallback } from 'react'

import { Divider } from '@mui/material'
import { MediaChannelScheduleEntry } from '@nativewaves/nw-cloud-sdk/media'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { MenuItemCopyId, MenuItemDelete } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useMediaChannelEntryDeleteMutation } from 'hooks/mutations/publishing'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<MediaChannelScheduleEntry>) => {
  const { t } = useTranslation(['common', 'entity', 'domain'])
  const { enqueueSnackbar } = useSnackbar()

  const { mutate: deleteMediaChannelEntry } = useMediaChannelEntryDeleteMutation()

  const handleDeleteMediaChannelEntry = useCallback(() => {
    onClose()

    deleteMediaChannelEntry(
      { channelId: row.original.channelId, entryId: row.original.id },
      {
        onSuccess: () =>
          enqueueSnackbar(t('domain:MediaChannel.nameDelete', { name: row.original.name }), { variant: 'success' }),
      },
    )
  }, [deleteMediaChannelEntry, enqueueSnackbar, onClose, row.original.channelId, row.original.id, row.original.name, t])

  return (
    <>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <Divider sx={{ my: 1 }} component="li" />
      <MenuItemDelete onConfirm={handleDeleteMediaChannelEntry} />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
